import { Slider } from "..";
import * as S from "./styles";
import { useState } from "react";
import { FullScreenGallery } from "./fullscreen-gallery/FullScreenGallery";

const mountImages = (IMAGE: string, LINK?: string, COD_PRODUTO?: number): any => ([{
  IMAGE,
  LINK,
  COD_PRODUTO,
}]);

const ProductGallery = ({ image, COD_PRODUTO }: { image: string, COD_PRODUTO: number }) => {
  const [fullScreenImage, setFullScreenImage] = useState(false);

  const handleImageClick = () => {
    setFullScreenImage(true);
  };

  const handleCloseFulScreen = () => {
    setFullScreenImage(false);
  };

  return (
    <>
      <S.ProductGalleryWrapper>
        <Slider
          dots
          canSwipe
          isGallery
          autoplay={false}
          slidesToShow={1}
          id="main-gallery"
          slides={mountImages(image, undefined, COD_PRODUTO)}
          openFullScreen={handleImageClick}
          closeFullScreen={handleCloseFulScreen}
        />
      </S.ProductGalleryWrapper>

      {fullScreenImage && (
        <FullScreenGallery
          images={mountImages(image, undefined, COD_PRODUTO)}
          handleCloseFulScreen={handleCloseFulScreen}
        />
      )}
    </>
  );
};

export default ProductGallery;
